module.exports = __webpack_public_path__ + "img/043-meat.119d7fe7.svg";